import React, { ReactNode } from 'react';
import { Chip } from '@material-ui/core';

export type StatusType = {
  status: ReactNode;
  bgcolor: string;
  tiny?: boolean;
};

const StatusChip = ({ status, bgcolor, tiny }: StatusType) => (
  <Chip
    size='small'
    label={status}
    style={{
      borderRadius: 5,
      color: 'white',
      background: bgcolor,
      fontSize: !tiny ? 'inherit' : '11px',
      fontWeight: 600,
      textTransform: 'uppercase',
    }}
  />
);

export { StatusChip };
